import TechnologiesSlider from './TecnologiesSlider';
import { TechnologyObject } from './types';

type Props = {
  technologies?: TechnologyObject[];
  className?: string;
};

const Technologies: React.FC<Props> = ({ technologies = [], className }) => {
  if (!technologies?.length) return null;

  return (
    <div id="pdpTechnologies" className={className}>
      <TechnologiesSlider technologies={technologies} />
    </div>
  );
};

export default Technologies;
